<template>
  <div>
    <head-individ />
    <another-site />
    <div class="container">
      <div class="healthIndivid">
        <div class="healthIndivid-left">
          <p
            class="healthIndivid-left__title"
            v-html="HealthInd[1].title"
          />
          <p
            class="healthIndivid-left__sub"
            v-html="HealthInd[1].desc"
          />
          <div class="healthIndivid-left__type">
            <div class="healthIndivid-left__type__par">
              <p
                class="title"
                v-html="HealthInd[1].sub_type[0].title"
              />
              <p
                class="sub"
                v-html="HealthInd[1].sub_type[0].desc"
              />
            </div>
            <div class="healthIndivid-left__type__par">
              <p
                class="title"
                v-html="HealthInd[1].sub_type[1].title"
              />
              <p
                class="sub"
                v-html="HealthInd[1].sub_type[1].desc"
              />
            </div>
            <div class="healthIndivid-left__type__par">
              <p
                class="title"
                v-html="HealthInd[1].sub_type[2].title"
              />
              <p
                class="sub"
                v-html="HealthInd[1].sub_type[2].desc"
              />
            </div>
          </div>
          <div class="healthIndivid-left__btn white_hover__btn">
            <a :href="$i18n.locale === 'en' ? 'https://cic.kz/?scroll=bottom' : HealthInd[1].link">
              <button>
                {{ $i18n.locale === 'en' ? 'MORE INFORMATION' : $t('buttons.moreBtn1')+" kupipolis.kz" }}
              </button>
            </a>
          </div>
        </div>
        <div class="healthIndivid-left__btn__mobile white_hover__btn">
          <a :href="$i18n.locale === 'en' ? 'https://cic.kz/?scroll=bottom' : HealthInd[1].link">
            <button>
              {{ $i18n.locale === 'en' ? 'MORE INFORMATION' : $t('buttons.moreBtn1')+" kupipolis.kz" }}
            </button>
          </a>
        </div>
        <div class="healthIndivid-right">
          <img
            :src="cdn + HealthInd[1].icon"
            alt=""
          >
        </div>
      </div>
      <div class="healthIndivid">
        <div class="healthIndivid-left">
          <p
            class="healthIndivid-left__title"
            v-html="HealthInd[2].title"
          />
          <p
            class="healthIndivid-left__sub"
            v-html="HealthInd[2].desc"
          />
          <div class="healthIndivid-left__type">
            <div class="healthIndivid-left__type__par">
              <p
                class="title"
                v-html="HealthInd[2].sub_type[0].title"
              />
              <p
                class="sub"
                v-html="HealthInd[2].sub_type[0].desc"
              />
            </div>
            <div class="healthIndivid-left__type__par">
              <p
                class="title"
                v-html="HealthInd[2].sub_type[1].title"
              />
              <p
                class="sub"
                v-html="HealthInd[2].sub_type[1].desc"
              />
            </div>
            <div class="healthIndivid-left__type__par">
              <p
                class="title"
                v-html="HealthInd[2].sub_type[2].title"
              />
              <p
                class="sub"
                v-html="HealthInd[2].sub_type[2].desc"
              />
            </div>
          </div>
          <div class="healthIndivid-left__btn white_hover__btn">
            <a :href="$i18n.locale === 'en' ? 'https://cic.kz/?scroll=bottom' : HealthInd[2].link">
              <button>
                {{ $i18n.locale === 'en' ? 'MORE INFORMATION' : $t('buttons.moreBtn1')+" kupipolis.kz" }}
              </button>
            </a>
          </div>
        </div>
        <div class="healthIndivid-left__btn__mobile white_hover__btn">
          <a :href="$i18n.locale === 'en' ? 'https://cic.kz/?scroll=bottom' : HealthInd[2].link">
            <button>
              {{ $i18n.locale === 'en' ? 'MORE INFORMATION' : $t('buttons.moreBtn1')+" kupipolis.kz" }}
            </button>
          </a>
        </div>
        <div class="healthIndivid-right">
          <img
            :src="cdn + HealthInd[2].icon"
            alt=""
          >
        </div>
      </div>
    </div>
    <service-main />
  </div>
</template>

<script>
import HeadIndivid from "../components/HeadIndivid.vue";
import anotherSite from "../components/anotherSite.vue";
import ServiceMain from "../components/ServiceMain.vue";
import axios from "axios";
import { mapState } from "vuex";
export default {
  components: { HeadIndivid, anotherSite, ServiceMain },
  data() {
    return {
      HealthInd: [],
      errors: [],
    };
  },
  computed: {
    ...mapState(["cdn"]),
  },
  created() {
    axios
      .get("V1/individual-insurance-health")
      .then((response) => {
        this.HealthInd = response.data.data;
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
};
</script>

<style lang="scss" scoped>
@mixin fontStyle($family, $style, $weight, $size, $lheight, $color) {
  font-family: $family;
  font-style: normal;
  font-weight: $weight;
  font-size: $size;
  line-height: $lheight;
  color: $color;
}
@mixin mobile {
  @media (min-width: 320px) and (max-width: 425px) {
    @content;
  }
}
@mixin tablet {
  @media (min-width: 425px) and (max-width: 769px) {
    @content;
  }
}
@mixin tablet-1024 {
  @media (min-width: 769px) and (max-width: 1023px) {
    @content;
  }
}
@mixin desktop {
  @media (min-width: 1023px) and (max-width: 1440px) {
    @content;
  }
}
@mixin desktop-max {
  @media (min-width: 1440px) and (max-width: 2560px) {
    @content;
  }
}

.healthIndivid {
  background: #efefef;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 85px;
  margin-bottom: 70px;
  padding: 65px 55px 60px 70px;
  &-left {
    width: 65%;
    &__title {
      @include fontStyle(Roboto, normal, 500, 36px, 43px, #373737);
      letter-spacing: 0.03em;
      text-transform: uppercase;
    }
    &__sub {
      @include fontStyle(Roboto, normal, 300, 18px, 22px, #373737);
    }
    &__type {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      &__par {
        width: 250px;
        margin-left: 21px;
        &:first-child {
          margin-left: 0;
        }
        &:nth-child(2) {
          margin-left: 15px;
        }
        .title {
          @include fontStyle(Roboto, normal, 400, 24px, 29px, #373737);
        }
        .sub {
          @include fontStyle(Roboto, normal, 300, 15px, 19px, #373737);
        }
      }
    }
    &__btn {
      margin-top: 15px;
      &__mobile {
        display: none;
      }
      button {
        width: 280px;
        height: 69px;
        background-color: #fff;
        // background: linear-gradient(90deg, #FF4466 0%, #BE31CE 49.97%, #3641FF 100%);
        // border-radius: 15px;
        // border: none;
        // @include fontStyle(Roboto, normal, 600, 18px, 25px, #FFFFFF);
        // margin-top: 15px;
        // &:hover {
        //     border: 3px solid #BE31CE;
        // }
        a {
          color: #8948b1;
        }
        &:hover {
          span {
            text-decoration: underline;
          }
        }
      }
    }
  }
  &-right {
    img {
      width: 100%;
      min-width: 155px;
    }
  }
  &:hover {
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.35);
  }
  @include mobile() {
    margin: 30px 0;
    flex-wrap: wrap;
    border-radius: 3px;
    padding: 30px 20px;
    &-left {
      width: 100%;
      &__title {
        font-size: 16px;
        line-height: 17px;
        margin-bottom: 5px;
      }
      &__sub {
        font-size: 14px;
        line-height: 15px;
      }
      &__type {
        margin-top: 10px;
        flex-wrap: wrap;
        // &:nth-child(2) {
        //     margin-left: 0;
        // }
        &__par {
          width: 100%;
          margin-left: 0 !important;
          .title {
            font-size: 14px;
            line-height: 15px;
            font-weight: 600;
          }
          .sub {
            font-size: 14px;
            line-height: 15px;
            margin-top: -14px;
          }
        }
      }
      &__btn {
        display: none;
        &__mobile {
          display: block;
          text-align: center;
          margin: 0 auto;
          margin-top: 10px;
          // margin-bottom: -14%;
          order: 3;
          border-radius: 3px;
          button {
            background-color: #ffffff;
            min-width: 200px;
            height: 34px;
            border-radius: 3px;
            font-size: 12px;
            line-height: 14px;
            a {
              color: #8948b1;
            }
          }
        }
      }
    }
    &-right {
      text-align: center;
      margin: 0 auto;
      width: 100%;
      img {
        width: 142px;
        min-width: 140px;
        margin-top: -5px;
      }
    }
  }
  @include tablet() {
    margin: 30px 0;
    flex-wrap: wrap;
    border-radius: 3px;
    padding: 20px;
    &-left {
      width: 100%;
      &__title {
        font-size: 16px;
        line-height: 17px;
      }
      &__sub {
        font-size: 14px;
        line-height: 15px;
      }
      &__type {
        margin-top: 10px;
        flex-wrap: wrap;
        &__par {
          margin-left: 0;
          &:nth-child(2) {
            margin-left: 0;
          }
          .title {
            font-size: 14px;
            line-height: 15px;
            font-weight: 600;
          }
          .sub {
            font-size: 14px;
            line-height: 15px;
            margin-top: -14px;
          }
        }
      }
      &__btn {
        display: none;
        &__mobile {
          display: block;
          text-align: center;
          margin: 0 auto;
          margin-top: 10px;
          // margin-bottom: -12%;
          order: 3;
          border-radius: 3px;
          button {
            min-width: 184px;
            max-width: 210px;
            height: 34px;
            border-radius: 3px;
            font-size: 12px;
            line-height: 14px;
            background-color: #ffffff;
            a {
              color: #8948b1;
            }
          }
        }
      }
    }
    &-right {
      margin: 0 auto;
      text-align: center;
      width: 100%;
      img {
        min-width: 140px;
        width: 144px;
        margin-top: 10px;
      }
    }
  }
  @include tablet-1024() {
    flex-wrap: wrap;
    &-left {
      &__title {
        font-size: 30px;
        line-height: 35px;
      }
      &__sub {
        padding-top: 20px;
        font-size: 12px;
        line-height: 16px;
      }
      &__btn {
        button {
          width: 240px;
          height: 50px;
          border-radius: 8px;
          font-size: 13px;
          line-height: 18px;
        }
      }
      &__type {
        .title {
          font-size: 15px;
          line-height: 22px;
          margin-bottom: 0;
        }
        .sub {
          font-size: 10px;
          line-height: 13px;
        }
      }
    }
    &-right {
      margin: 0 auto;
      img {
        min-width: 162px;
        width: 184px;
        margin-top: 30px;
      }
    }
  }
  @include desktop() {
    &-left {
      &__title {
        font-size: 28px;
        line-height: 33px;
        padding-bottom: 10px;
      }
      &__sub {
        font-size: 17px;
        line-height: 19px;
      }
      &__type {
        &__par {
          .title {
            font-size: 18px;
            line-height: 18px;
          }
          .sub {
            font-size: 13px;
            line-height: 14px;
          }
        }
      }
      &__btn {
        button {
          width: 200px;
          height: 50px;
          border-radius: 8px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
